import React, { useState, useEffect } from "react";
import { CircularProgress, Button } from "@mui/material/";
import { useTranslation } from "react-i18next";
import AssetItem from "./AssetItem";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles";

const Checked = ({ data, hdlShowMore, className }) => {
    const classes = makeStyles(styles)();
    const [assets, setAssets] = useState([
        <div
            key={0} // using style instead of className as on render it does not load classes
            style={{
                display: "flex",
                justifyContent: "center",
                padding: "3rem",
            }}
        >
            <CircularProgress />
        </div>,
    ]);
    const { t } = useTranslation();

    useEffect(() => {
        const items = data.map((item) => (
            <AssetItem
                key={item.id}
                assetType="checked"
                assetId={item.id}
                itemContent={item}
                auditImages={item.auditImages}
            />
        ));

        setAssets(items);
    }, [data]);

    return (
        <div className={classes.listContainer}>
            {assets}
            {assets.length ? (
                <Button onClick={hdlShowMore} className={className}>
                    {t("showMore").toUpperCase()}
                </Button>
            ) : null}
        </div>
    );
};

export default Checked;
